import React, { useState, useRef } from "react";
import Draggable from "react-draggable";
import RingCentralPremiumMeeting from "components/RingCentral/RingCentralPremiumMeeting/RingCentralPremiumMeeting";
import { DraggableContext } from "store/contexts/draggableModalContext";
import classNames from "classnames";

function RingCentralDragModal() {
  const [isMinimized, setMinimized] = useState(
    window.matchMedia("(max-width: 660px)").matches ? false : true
  );
  const dragModalRef = useRef(null);
  const [currentPosition, setCurrentPosition] = useState({
    xRate: 0,
    yRate: 0,
  });
  const [disabledDrag] = useState(
    window.matchMedia("(max-width: 991px)").matches ? true : false
  );

  const onDrag = (e, data) => {
    setCurrentPosition({ xRate: data.lastX, yRate: data.lastY });
  };

  const handleMinimize = () => {
    if (!isMinimized) {
      setMinimized(true);
      return;
    }
    dragModalRef.current.style.transform = "translate(0px, 0px)";
    setMinimized(false);
  };

  return (
    <DraggableContext.Provider
      value={{
        handleMinimize,
        isMinimized,
        disabledDrag,
      }}
    >
      <Draggable
        defaultPosition={{ x: 0, y: 0 }}
        scale={1}
        handle=".premiumModalHeader"
        position={{
          x: currentPosition.xRate,
          y: currentPosition.yRate,
        }}
        disabled={!disabledDrag ? (isMinimized ? false : true) : true}
        onDrag={onDrag}
        bounds="body"
      >
        <div
          className={classNames({
            "draggable-piece": true,
            "minimized-draggable-piece": isMinimized ? true : false,
          })}
          ref={dragModalRef}
        >
          <RingCentralPremiumMeeting />
        </div>
      </Draggable>
    </DraggableContext.Provider>
  );
}

export default RingCentralDragModal;
